import { BetSlipResultStatus, BetSlipType, SystemBetTypesEnum } from 'shared-types';
import { type BetSlipRejectStatus, BetStatus } from '@/types/coupons.enum';

export type Bet = {
  id: number;
  betSlipId: number;
  parentBetId: null;
  selectionId: number;
  odds: string;
  numerator: number;
  denominator: number;
  status: BetStatus;
  createdAt: string;
  updatedAt: string;
}

export type ApiBetsItem = {
  id: number;
  guid: string;
  preset: null | SystemBetTypesEnum;
  userId: number;
  promo: string | null;
  currency: string | null;
  stakeAmount: string;
  maxPayout: string;
  vendorCurrency: string;
  vendorStakeAmount: string;
  vendorMaxPayout: string;
  payout: string | null;
  refund: string | null;
  type: BetSlipType;
  status: null | BetSlipResultStatus;
  rejectStatus: null | BetSlipRejectStatus;
  parentBetSlipId: number;
  parentBetSlipGuid: string;
  createdAt: string;
  updatedAt: string;
  bets: Bet[];
}

export type ApiBetsTotals = {
  stakeAmount: string;
  paidOutAmount: string;
  refundAmount: string;
  activeAmount: string;
}

export const SystemBetTypesLimitations = {
  [SystemBetTypesEnum.BxMul2L]: { bets: 0, legsMin: 2, legsMax: 16 },
  [SystemBetTypesEnum.BxMul3L]: { bets: 0, legsMin: 3, legsMax: 16 },
  [SystemBetTypesEnum.BxMul4L]: { bets: 0, legsMin: 4, legsMax: 16 },
  [SystemBetTypesEnum.BxMul5L]: { bets: 0, legsMin: 5, legsMax: 16 },
  [SystemBetTypesEnum.BxMul6L]: { bets: 0, legsMin: 6, legsMax: 16 },
  [SystemBetTypesEnum.BxMul7L]: { bets: 0, legsMin: 7, legsMax: 16 },
  [SystemBetTypesEnum.BxMul8L]: { bets: 0, legsMin: 8, legsMax: 16 },
  [SystemBetTypesEnum.BxMul9L]: { bets: 0, legsMin: 9, legsMax: 16 },
  [SystemBetTypesEnum.BxMul10L]: { bets: 0, legsMin: 10, legsMax: 16 },
  [SystemBetTypesEnum.BxMul11L]: { bets: 0, legsMin: 11, legsMax: 16 },
  [SystemBetTypesEnum.BxMul12L]: { bets: 0, legsMin: 12, legsMax: 16 },
  [SystemBetTypesEnum.BxMul13L]: { bets: 0, legsMin: 13, legsMax: 16 },
  [SystemBetTypesEnum.BxMul14L]: { bets: 0, legsMin: 14, legsMax: 16 },
  [SystemBetTypesEnum.BxMul15L]: { bets: 0, legsMin: 15, legsMax: 16 },
  [SystemBetTypesEnum.BxMul16L]: { bets: 0, legsMin: 16, legsMax: 16 },
  [SystemBetTypesEnum.Patent]: { bets: 7, legsMin: 3, legsMax: 3 },
  [SystemBetTypesEnum.Lucky15]: { bets: 15, legsMin: 4, legsMax: 4 },
  [SystemBetTypesEnum.Lucky31]: { bets: 31, legsMin: 5, legsMax: 5 },
  [SystemBetTypesEnum.Lucky63]: { bets: 63, legsMin: 6, legsMax: 6 },
  [SystemBetTypesEnum.Trixie]: { bets: 4, legsMin: 3, legsMax: 3 },
  [SystemBetTypesEnum.Yankee]: { bets: 11, legsMin: 4, legsMax: 4 },
  [SystemBetTypesEnum.SupYankee]: { bets: 26, legsMin: 5, legsMax: 5 }, // aka Canadian
  [SystemBetTypesEnum.Heinz]: { bets: 57, legsMin: 6, legsMax: 6 },
  [SystemBetTypesEnum.SupHeinz]: { bets: 120, legsMin: 7, legsMax: 7 },
  [SystemBetTypesEnum.Goliath]: { bets: 247, legsMin: 8, legsMax: 8 },
};